import VModelMixin from "./vModelMixin";
import {mapMutations, mapState} from "vuex";

export default (fieldName, vuexStateName = 'profile', updateMutationName = 'profileFieldOnInput') => ({
  mixins: [VModelMixin],

  inject: {
    disabled: {
      default: false
    }
  },

  data() {
    return {
      defaultLabel: null,
      defaultPlaceholder: null,
    }
  },

  props: {
    required: {
      type: Boolean,
      default: false
    },
    label: {
      required: false,
      default: function () {
        return this.defaultLabel
      }
    },
    placeholder: {
      required: false,
      default: function () {
        return this.defaultPlaceholder
      }
    },
  },
  computed: {
    ...mapState([vuexStateName]),
    ...mapState({
      errors: state => {
        if (fieldName.startsWith('billing_address.') || fieldName.startsWith('shipping_address.') || fieldName.startsWith('identification.') || fieldName.startsWith('bank_account.')) {
          const fields = fieldName.split('.');
          let iden = state[vuexStateName].errors[fields[0]];
          if (iden && iden.length > 0) {
            return iden[0][fields[1]];
          }
          return '';
        }

        return state[vuexStateName].errors[fieldName]
      }
    }),
    computedLabel() {
      return this.label || this.defaultLabel
    },
    computedPlaceholder() {
      return this.placeholder || this.defaultPlaceholder
    }
  },
  watch: {
    [`${vuexStateName}.model.${fieldName}`]: {
      immediate: true,
      handler() {
        const fields = fieldName.split('.')
        if (fields.length === 1) {
          this.model = this[vuexStateName].model[fieldName]
        } else {
          this.model = this[vuexStateName].model[fields[0]][fields[1]]
        }
      }
    }
  },
  methods: {
    ...mapMutations([updateMutationName]),
    onInput(val) {
      this[updateMutationName]({field: fieldName, value: val || ''})
    }
  }
})
